import { useQuery } from "@apollo/client";
import { logout } from "../../functions";
import { ALL_USERS } from "../../GraphQl/Queries";
import { ActionTypes } from "../constants/ActionTypes";

export const getAllUsers = (data) => (dispatch) => {
    // const { error, loading, data } = useQuery(ALL_USERS);

    try {

        dispatch({ type: ActionTypes.GET_ALL_USER_DATA_ATTEMPT });
        if (data.length > 0)
            dispatch({ type: ActionTypes.GET_ALL_USER_DATA_SUCCESS, payload: data });
    }
    catch (err) {

        dispatch({ type: ActionTypes.GET_ALL_USER_DATA_FAIL, payload: err });

    }
}

export const setProfile = (data) => (dispatch) => {
    localStorage.setItem('shub-roles', data?.user?.userType)

    // localStorage.setItem('shub-roles', "SUPER_ADMIN")
    try {
        dispatch({ type: ActionTypes.SET_PROFILE, payload: data?.user })
    }
    catch (err) {
        dispatch({ type: ActionTypes.SET_PROFILE_FAIL })
    }
}
export const updateProfile = (data) => (dispatch) => {

    localStorage.setItem('shub-roles', data?.userType)

    try {
        dispatch({ type: ActionTypes.SET_PROFILE, payload: data })
    }
    catch (err) {
        dispatch({ type: ActionTypes.SET_PROFILE_FAIL })
    }
}
export const logOut = () => (dispatch) => {
    logout();
    return dispatch({ type: ActionTypes.LOGOUT })
}


